
import { a11yProps, sizeTab } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import TableRevisionSolicitudCanje from "../../shared/TableRevisionSolicitudCanje";
import TableRevisionSolicitudEvento from "../../shared/TableRevisionSolicitudEvento";

export default function RevisionEventoCanjePage() {

  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene
      title="Revisión Solicitud Evento/Canje"
      py={2}
      visibleReport={true}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Canjes'} {...a11yProps(0)} />
          <Tab label={'Eventos'} {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TableRevisionSolicitudCanje />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TableRevisionSolicitudEvento />
      </CustomTabPanel>

    </SingleTableBoxScene >
  );

}

